"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionLevel = void 0;
var PermissionLevel;
(function (PermissionLevel) {
    PermissionLevel["Read"] = "read";
    PermissionLevel["Write"] = "write";
    PermissionLevel["None"] = "none";
})(PermissionLevel = exports.PermissionLevel || (exports.PermissionLevel = {}));
